import { __decorate } from "tslib";
import { AutoEncoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { PermissionsByRole } from './Permissions';
export class GroupPrivateSettings extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.defaultEmailId = null;
        this.permissions = PermissionsByRole.create({});
    }
}
__decorate([
    field({ decoder: StringDecoder, nullable: true, version: 10 })
], GroupPrivateSettings.prototype, "defaultEmailId", void 0);
__decorate([
    field({ decoder: PermissionsByRole, version: 60, optional: true })
], GroupPrivateSettings.prototype, "permissions", void 0);
export const GroupPrivateSettingsPatch = GroupPrivateSettings.patchType();
//# sourceMappingURL=GroupPrivateSettings.js.map